<script>
    import { onMount, onDestroy, tick, createEventDispatcher } from "svelte";
    import * as bootstrap from "bootstrap"; 
    import * as userService from "../service.svelte.js";
    import { notificate } from "../../../services/notification.js";
    import { PowerTable } from "@muonw/powertable";
    import powerTableService from "../../../services/powerTable";
    import Form from "../_form.svelte";
    import MassiveAddForm from "../_form_massive_add.svelte";
    import { user } from "../user.state.svelte.js";
    import { dateText } from "../../../js/utils.js";
    import { format, locale } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let { data = [], loggedUser, userCanAdd } = $props();

    let ShowMassiveAdditionForm = $state(false);

    let showed_user_add_msg_once =  $derived(loggedUser.showed_user_add_msg_once);
    let show_user_add_msg = $derived(loggedUser.show_user_add_msg);

    let selected_rows = $state([]);
    let checkbox;
    let tableElement = $state();
    let formModal;
    let formEditModal;
    
    // Keys to force re-rendering of forms
    let reload_add_modal = $state(false);
    let reload_edit_modal = $state(false);
    
    let ptData = JSON.parse(JSON.stringify(data));
    let is_requesting = $state(false);

    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            if (
                row.is_notification_enabled &&
                row.is_notification_enabled == "true"
            ) {
                row.is_notification_enabled = `<div class=""><i class="fas fa-check text-success"></i></div>`;
            } else {
                row.is_notification_enabled = `<div class=""><i class="fas fa-times text-danger"></i></div>`;
            }
            if (row["last_login_at"]) {
                let last_login_at = row.last_login_at;
                row["last_login_at"] =
                    `<span title="${last_login_at}">${dateText(row["last_login_at"])}</span>`;
            }
            if (row["role"]) {
                row.role = $format(`page.user.roles.${row.role}`);
            }
        });
        deselectAll();
        return pageContent;
    };

    let ptOptions = $state({
        uniquePrefix: "userTable",
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: 10,
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            topBar: ["search"],
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        userFunctions: {
            customParse: parseRows,
        },
    });

    let ptInstructs = [
        { key: "select", title: "", filterable: false, sortable: false },
        { key: "email", title: "Email", filterable: false },
        {
            key: "label",
            title: $format("list.columns.role"),
            filterable: false,
        },
        {
            key: "last_login_at",
            title: $format("list.columns.last_login"),
            filterable: false,
            parseAs: "unsafe-html",
        },
        {
            key: "is_notification_enabled",
            title: $format("list.columns.notifications"),
            filterable: false,
            parseAs: "unsafe-html",
        },
    ];

    let handleDelete = async () => {
        let result = await notificate("confirm_delete", "modal", {
            massive: true,
            findings_warning: false,
        });
        if (!result.isConfirmed) {
            return false;
        }
        is_requesting = true;
        let ids = [];
        for (let row of selected_rows) {
            ids.push(row.id);
        }

        if (ids.includes(user.data.id)) return;

        let usersToDelete = data.filter((user) => ids.includes(user.id));

        usersToDelete.forEach((user, i)=>{
            userService.del(user)
                .then(()=>{
                    if(i == usersToDelete.length - 1){
                        is_requesting = false;
                        dispatch("del", user);
                    }
                })
                .catch(errors=>{
                    is_requesting = false;
                    return errors;
                })
            ;
        });
    }

    const handleAdd = async (event) => {
        let user = event.detail.savedUser;
        dispatch("add", user);
        if (formModal) formModal.hide();
        if (formEditModal) formEditModal.hide();
    }

    const handleMassiveAdd = async (event) => {
        let editedUsers = event.detail.results;
        for(let [index, editedUser] of Object.entries(editedUsers)){
            if(index == editedUsers.length - 1){
                dispatch("add");
                notificate('save_ok', "toast", {data: $format("page.user.plural"), is_massive:  true});
            }
        }
        if (formModal) formModal.hide();
    }

    const handleEditFn = async (event) => {
        let user = event.detail.user;
        dispatch("edit", user);
        if (formModal) formModal.hide();
        if (formEditModal) formEditModal.hide();
    };

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));

        let action = allPageSelected ? "deselect" : "select";

        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});

                if (!result.isConfirmed && result.dismiss !== "cancel") {
                    return selected_rows;
                }
            }

            let target_elements =
                result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));

            selected_rows = [...selected_rows, ...toAdd];
        } else {
            selected_rows = [];
        }

        powerTableService.toggleActionButtons(selected_rows);

        const domRows = document.querySelectorAll(
            `div[data-prefix='userTable'] table tbody tr`,
        );

        const selectedPtIds = new Set(
            selected_rows.map((r) => String(r.__PT_ID__)),
        );

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) {
                row.classList.add("selected");
            } else {
                row.classList.remove("selected");
            }
        });

        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const selectAllEventListener = () => {
        checkbox = document.querySelector(
            "th[data-key='select'][data-sortable='false']",
        );
        if (checkbox) {
            checkbox.addEventListener("click", selectAll);
        }
    };

    const selectRow = (event) => {
        let tData = tableElement.getData(false, [
            "options",
            "instructs",
            "data",
            "search",
            "filters",
            "pageData",
            "matchedData",
        ]);
        
        let current = event.detail.data;
        let idx = selected_rows.findIndex((r) => r.id == current.id);
        selected_rows = powerTableService.selectRows(
            selected_rows,
            current,
            idx,
            "userTable",
            tData.pageData,
        );
        let shouldDisableBtns = false;
        for (let row of selected_rows) {
            if (row.id === loggedUser.id) {
                shouldDisableBtns = true;
            }
        }
        if (shouldDisableBtns) {
            let btns = document.getElementsByClassName("btn-disabled");
            for (let btn of btns) {
                btn.setAttribute("disabled", true);
            }
        } else {
            powerTableService.toggleActionButtons(selected_rows);
        }
        return selected_rows;
    };

    const exportToJSON = (e) => {
        let currentData = tableElement.getData(
            false,
            "matchedData",
        ).matchedData;
        for (let item of currentData) {
            delete item.__PT_ID__;
            delete item.__PT_CB__;
            delete item.is_enabled;
            delete item.workspace_id;
            delete item.id;
        }
        let dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(currentData));
        let downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", `Usuarios_vulseek.json`);
        document.body.appendChild(downloadAnchorNode); 
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };

    const exportToCSV = async () => {
        let instructs = ptInstructs;
        let header = [];
        let titles = [];
        const data = tableElement.getData(false, "matchedData").matchedData;
        let items = JSON.parse(JSON.stringify(data));

        const replacer = (key, value) => (value === null ? "" : value); 

        instructs.forEach((col) => {
            if (col.key != "select") {
                header.push({ key: col.key, value: col.title });
            }

            if (col.title.includes(" "))
                col.title = col.title.replace(" ", "_");
        });

        const csv = [
            titles.join(";"), 
            ...items.map((row) =>
                header
                    .map((fieldName) =>
                        JSON.stringify(row[fieldName["key"]], replacer),
                    )
                    .join(";"),
            ),
        ].join("\r\n");

        let hiddenElement = document.createElement("a");
        hiddenElement.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download = `Usuarios_vulseek.csv`;
        hiddenElement.click();
    };

    onMount(async () => {
        await tick();
        
        const bs = typeof bootstrap !== 'undefined' ? bootstrap : window.bootstrap;

        if (bs) {
            const addModalEl = document.getElementById("user-add-modal");
            const editModalEl = document.getElementById("user-edit-modal");

            if (addModalEl) formModal = new bs.Modal(addModalEl);
            if (editModalEl) formEditModal = new bs.Modal(editModalEl);
        }

        if (
            data.length <= 1 &&
            show_user_add_msg != false &&
            !showed_user_add_msg_once
        ) {
            notificate("modal_users_helper", "modal");
            let result = await notificate("modal_users_helper", "modal");
            showed_user_add_msg_once = true;
            user.data.showed_user_add_msg_once = true;
            if (result.value) {
                userService
                    .saveLoggedUserSettings(
                        { key: "show_user_add_msg", value: false },
                        [],
                        { no_toaster: true },
                    )
                    .then(() => {
                        show_user_add_msg = false;
                        user.data.show_user_add_msg = false;
                    });
            }
        }
        selectAllEventListener();
    });

    onDestroy(() => {
        if (checkbox) checkbox.removeEventListener("click", selectAll);
    });
</script>

<style>
    .overlay-wrapper div {
        display: none;
    }
    .overlay-wrapper div.overlay{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;
    }
</style>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <div class="float-end">
                    {#if userCanAdd}
                        <button
                            class="btn btn-secondary table-button btn-add btn-xs t-add-user-btn"
                            tabindex="0"
                            aria-controls="userTable"
                            aria-label="users"
                            type="button"
                            title={$format("buttons.add")}
                            id="userAddBtn"
                            onclick={() => {
                                // Force Svelte to recreate the form BEFORE showing modal
                                reload_add_modal = !reload_add_modal;
                                ShowMassiveAdditionForm = false;
                                if (formModal) formModal.show();
                            }}
                            ><i class="fa fa-plus"></i></button>
                        
                        <button
                            class="btn btn-secondary table-button btn-disabled btn-delete btn-xs t-delete-user-btn"
                            tabindex="0"
                            aria-controls="userTable"
                            aria-label="users"
                            type="button"
                            title={$format("buttons.delete")}
                            id="userDeleteBtn"
                            onclick={handleDelete}
                            ><i class="fa fa-trash" disabled></i></button>
                        
                        <button
                            class="btn btn-secondary table-button btn-disabled btn-edit btn-xs t-edit-user-btn"
                            tabindex="0"
                            aria-controls="userTable"
                            aria-label="users"
                            type="button"
                            title={$format("buttons.edit")}
                            id="userEditBtn"
                            onclick={() => { 
                                // Force Svelte to recreate the form BEFORE showing modal
                                reload_edit_modal = !reload_edit_modal; 
                                if (formEditModal) formEditModal.show(); 
                            }}
                            disabled><i class="fa fa-edit"></i></button>
                    {/if}
                    <button
                        class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-user-btn"
                        tabindex="0"
                        aria-controls="userTable"
                        aria-label="users"
                        type="button"
                        title={$format("buttons.refresh")}
                        id="userRefreshBtn"
                        onclick={() => dispatch("tableRefresh")}
                        ><i class="fa fa-sync-alt"></i></button>
                    
                    <button
                        class="btn btn-secondary table-button btn-export btn-xs t-json-user-btn"
                        tabindex="0"
                        aria-controls="userTable"
                        aria-label="users"
                        type="button"
                        title={$format("buttons.json")}
                        id="userJSONbtn"
                        onclick={exportToJSON}
                        ><i class="fab fa-js-square" style="font-size: 18px;"
                        ></i></button>
                    
                    <button
                        class="btn btn-secondary table-button btn-export btn-xs t-csv-user-btn"
                        tabindex="0"
                        aria-controls="userTable"
                        aria-label="users"
                        type="button"
                        title={$format("buttons.csv")}
                        id="userCSVbtn"
                        onclick={exportToCSV}
                        ><i class="fa fa-file-csv" style="font-size: 18px;"
                        ></i></button>
                    
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <div class="overlay-wrapper">
                        <div class="text-center" class:overlay={is_requesting}><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
                    </div>
                    <PowerTable {ptData} {ptOptions} {ptInstructs} on:rowClicked="{e=>selectRow(e)}" bind:this={tableElement}>
                        <div slot="noResults">
                            {$format("results_not_found")}
                        </div>
                    </PowerTable>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ADD MODAL -->
<div
    class="modal fade"
    id="user-add-modal"
    tabindex="-1"
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("add")} {$format("user")}</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    onclick={() => formModal && formModal.hide()}
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_add_modal}
                    {#if !ShowMassiveAdditionForm}
                        <Form on:save={handleAdd} on:cancel={() => formModal && formModal.hide()} />
                    {:else}
                        <MassiveAddForm on:save={handleMassiveAdd} on:cancel={() => formModal && formModal.hide()} />
                    {/if}

                    <a
                        class="float-end"
                        href="#"
                        onclick={(e) => {
                            e.preventDefault();
                            ShowMassiveAdditionForm = !ShowMassiveAdditionForm;
                        }}
                    >
                        {#if !ShowMassiveAdditionForm}
                            {$format("page.asset.form.fields.enable")}
                        {:else}
                            {$format("page.asset.form.fields.disable")}
                        {/if}
                        {$format("page.asset.form.fields.massive_upload")}
                    </a>
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END ADD MODAL-->

<!-- EDIT MODAL -->
<div
    class="modal fade"
    id="user-edit-modal"
    tabindex="-1"
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("buttons.edit")}
                    {$format("user")}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    onclick={() => formEditModal && formEditModal.hide()}
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    <Form
                        userToEdit={selected_rows[0]}
                        on:save={handleEditFn}
                        on:cancel={() => formEditModal && formEditModal.hide()}
                    />
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->